
import styled, { css } from 'styled-components';
import { FontWeight } from 'components/Text';
import Colors from 'constants/Colors';

export const FileContainer = styled.div`
margin-top: 20px;
${({ color }) => `border: 1px solid ${color}`};
background: #fff;
margin-bottom: 40px;
resize: both;
`;

export const FileContent = styled.div`
 display:flex;
 position: relative;
 overflow: hidden;
 overflow-x: scroll; 
`;

export const File = styled.div`
 top: 0;
 left: 0;
`;

export const FilePDF = styled.iframe`
  width: 100%;
  height: 70vh;
  top: 0;
  left: 0;
`;

export const FileHeader = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
text-transform: uppercase;
font-weight:bold;
font-size: 14px;
padding:10px;
${({ color }) => `background-color:${color}`};
color:${Colors.WHITE};
`;

export const Actions = styled.div`
display:flex;
justify-content:space-evenly;
background-color:transparent;
width:60px;
`;

export const ContPages = styled.div`
display:flex;
justify-content:space-evenly;
align-items: center;
background-color:transparent;
`;

export const FileTitle = styled.div`
display:flex;
width: 30% ;
justify-content:flex-start;
align-items: center;
background-color:transparent;
`;